module.exports = function() {
  return new Worker(__webpack_public_path__ + "adb7e617cee8e9ea3672.worker.js");
};